import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';

import {FormsModule} from '@angular/forms';

@Component({
  selector: 'app-translation-message-editor',
  imports: [
    FormsModule
],
  templateUrl: './translation-message-editor.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './translation-message-editor.component.scss'
})
export class TranslationMessageEditorComponent implements OnChanges {
  @Input() text!: string | null | undefined;
  @Input() loading = false;
  @Output('textChange') textChangeEvent = new EventEmitter<string>();
  @Output('textFocus') textFocusEvent = new EventEmitter<void>();

  editMode = false;
  previousText!: string | null | undefined;

  @ViewChild('textAreaElement') set setTextAreaElement(element: ElementRef) {
    if (element) {
      element.nativeElement.focus();
      setTimeout(() => {
        element.nativeElement.style.height = 'auto';
        element.nativeElement.style.height = (element.nativeElement.scrollHeight + 3) + 'px';
      });
    }
  }

  hasText(): boolean {
    return !!this.text;
  }

  click(): void {
    this.textFocusEvent.emit();
  }

  edit(): void {
    this.editMode = true;
    this.previousText = this.text;
  }

  save(): void {
    this.editMode = false;
    this.textChangeEvent.emit(this.text ?? '');
  }

  cancel(): void {
    this.editMode = false;
    this.text = this.previousText;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['text']) {
      this.previousText = changes['text'].currentValue;
    }
  }
}
